import React, { useState, useEffect } from "react";
import ItemService from "../../services/supplier_appCommonService";
import LoaderSmall from "../LoaderSmall";

export default function CategoryCard({
  title,
  queryName,
  icon: Icon,
  onClick,
  fetchFunction,
  splitCount,
  valueKey,
  value: directValue,
  directCount,
  loading = false,
}) {
  const [count, setCount] = useState(0);
  const [value, setValue] = useState(0);

  const toMM = (num) => (!num ? "0" : (num / 1000000).toFixed(1));

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        // Direct values from Dashboard API
        if (directCount !== undefined || directValue !== undefined) {
          if (!mounted) return;

          setCount(directCount ?? 0);
          setValue(directValue ?? 0);
          return;
        }

        // Individual API Call
        const res = fetchFunction
          ? await fetchFunction()
          : await ItemService.generateQuery({ queryName });

        let count = 0;
        let value = 0;

        if (
          typeof res?.data === "object" &&
          res?.data !== null &&
          !Array.isArray(res.data)
        ) {
          count = res.data.count ?? 0;
          value = res.data.value ?? 0;
        } else if (
          Array.isArray(res?.data) &&
          res.data[0]?.count !== undefined
        ) {
          count = res.data[0].count ?? 0;
          value = res.data[0].value ?? 0;
        } else if (typeof res?.data === "number") {
          count = res.data;
        } else if (typeof res?.total === "number") {
          count = res.total;
        }

        if (
          valueKey &&
          Array.isArray(res?.data) &&
          typeof res?.total === "number"
        ) {
          if (count === 0) count = res.total;

          if (value === 0) {
            value = res.data.reduce((sum, row) => {
              const v = Number(row?.[valueKey]);
              return sum + (isNaN(v) ? 0 : v);
            }, 0);
          }
        }

        if (!mounted) return;

        setCount(count);
        setValue(value);
      } catch (err) {
        console.error("CategoryCard Error:", err);

        if (mounted) {
          setCount(0);
          setValue(0);
        }
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [queryName, fetchFunction, valueKey, directCount, directValue]);

  return (
    <div
      className="p-3 rounded shadow-sm"
      style={{
        background: "var(--category-card-background)",
        cursor: "pointer",
        borderRadius: "12px",
        minHeight: "150px",
        transition: "transform .2s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) =>
        (e.currentTarget.style.transform = "translateY(-4px)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.transform = "translateY(0)")
      }
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5
          className="mb-0"
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "var(--category-card-title-color)",
          }}
        >
          {title}
        </h5>

        <span
          style={{
            fontSize: "13px",
            color: "#999",
            fontWeight: 500,
          }}
        >
          View All <i className="bi bi-chevron-right ms-1"></i>
        </span>
      </div>

      {/* Body */}
      <div className="d-flex align-items-center gap-3">
        {/* Icon */}
        <div
          style={{
            width: 60,
            height: 60,
            minWidth: 60,
            borderRadius: 12,
            background: "var(--category-card-icon-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {typeof Icon === "string" ? (
            <i
              className={Icon}
              style={{
                fontSize: 32,
                color: "var(--category-card-icon-color)",
              }}
            />
          ) : (
            Icon && (
              <Icon
                size={32}
                color="var(--category-card-icon-color)"
              />
            )
          )}
        </div>

        {/* Loader */}
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              flex: 1,
              height: "70px",
            }}
          >
            <LoaderSmall isLoading={true} />
          </div>
        ) : splitCount ? (
          <div>
            <h2
              className="mb-0"
              style={{
                fontSize: "30px",
                fontWeight: 700,
                color: "var(--category-card-title-color)",
              }}
            >
              {String(count).padStart(2, "0")}
              <span style={{ color: "#999" }}> / </span>
              {String(value).padStart(2, "0")}
            </h2>

            <span
              style={{
                fontSize: "13px",
                color: "var(--category-card-value-color)",
                fontWeight: 600,
              }}
            >
              Count
            </span>
          </div>
        ) : (
          <div>
            <h2
              className="mb-0"
              style={{
                fontSize: "32px",
                fontWeight: 700,
                color: "var(--category-card-title-color)",
              }}
            >
              {count}
            </h2>

            <span
              style={{
                fontSize: "13px",
                color: "var(--category-card-value-color)",
                fontWeight: 600,
              }}
            >
              ₹ {Number(value).toLocaleString()} ({toMM(value)}M)
            </span>
          </div>
        )}
      </div>
    </div>
  );
}